import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=7f4f105e"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4f105e')) {
      api.createRecord('7f4f105e', component.options)
    } else {
      api.reload('7f4f105e', component.options)
    }
    module.hot.accept("./ProductDetails.vue?vue&type=template&id=7f4f105e", function () {
      api.rerender('7f4f105e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ProductDetails.vue"
export default component.exports